import { House, Mail, PhoneCall } from 'lucide-react'
import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaTwitter } from 'react-icons/fa6'
import { useLocation, useNavigate } from 'react-router-dom'

import { navigateCMSpage, navigatetoHome } from '@/utils/footer-navigations'

function Footer() {
  const location = useLocation()
  const navigate = useNavigate()

  const navigateHome = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      navigate('/').then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }

  return (
    <div className="bg-footer-purple w-full z-1">
      <div className="px-4 pt-25 md:pt-20 sm:px-6 md:px-12 xl:w-7xl m-auto py-4 sm:py-8 lg:pt-10">
        {/* image logo */}
        <img src="/FooterLogo.svg" className="w-32 h-32 mb-8 sm:mb-12" alt="footerlogo" />

        <div className="flex flex-col lg:flex-row justify-between text-white gap-6 lg:gap-0 mb-2">
          {/* Contacts */}
          <div className="flex flex-col items-start gap-4">
            <h1 className="text-2xl text-[18px] md:text-[22px] font-semibold">Company</h1>
            <ul className="flex flex-col text-md gap-2">
              <li className=" cursor-pointer hover:underline" onClick={navigateHome}>
                Home
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigatetoHome('/#services')}
              >
                Services
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigateCMSpage('about-us')}
              >
                About Us
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigatetoHome('/#prices')}
              >
                Prices
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigateCMSpage('career')}
              >
                Career
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigatetoHome('/contact-us')}
              >
                Contact Us
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="flex flex-col items-start gap-4">
            <h1 className="text-2xl text-[18px] md:text-[22px] font-semibold">Legal</h1>
            <ul className="flex flex-col text-md gap-2">
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigateCMSpage('privacy-policy')}
              >
                Privacy Policy
              </li>
              <li
                className=" cursor-pointer hover:underline"
                onClick={() => navigateCMSpage('terms-and-conditions')}
              >
                Terms & Conditions
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div className="flex flex-col items-start gap-4">
            <h1 className="text-2xl text-[18px] md:text-[22px] font-semibold">Connect</h1>
            <ul className="flex flex-col text-md gap-4">
              <li>
                <a
                  href="mailto:support@stampin.io"
                  className="flex gap-2 items-start hover:underline"
                >
                  <Mail className="min-w-[20px]" />
                  <span>support@stampin.io</span>
                </a>
              </li>
              <li>
                <a href="tel:+16460000000" className="flex gap-2 items-start hover:underline">
                  <PhoneCall className="min-w-[20px]" />
                  <span>+1 646 000 00 00</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=47+W+13th+St,+New+York,+NY+10011,+USA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-2 items-start hover:underline"
                >
                  <House className="min-w-[20px]" />
                  <span>47 W 13th St, New York, NY 10011, USA</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* copyright claim */}
      <div className=" border-t border-footer-border-purple w-full px-4 sm:px-6 md:px-12">
        <div className="flex flex-col sm:flex-row justify-between items-center text-white px-4 py-3 sm:px-6 md:px-12 xl:w-7xl m-auto sm:py-6 lg:pt-6">
          <p className="text-center sm:text-left text-[15px] font-normal mb-4 sm:mb-0">
            © 2025 Copyright Stampin. All Rights Reserved
          </p>
          <ul className="flex gap-4 text-2xl">
            {/* <li>
              <FaFacebookF />
            </li>
            <li>
              <FaTwitter />
            </li> */}
            <li>
              <FaTiktok
                className="cursor-pointer"
                onClick={() =>
                  window.open('https://www.tiktok.com/@stampin.io?_t=ZS-90IcKErmx8e&_r=1', '_blank')
                }
              />
            </li>
            <li>
              <FaInstagram
                className="cursor-pointer"
                onClick={() =>
                  window.open(
                    'https://www.instagram.com/stampin.io?igsh=ejVsdGM1NWJ4ZmIw',
                    '_blank'
                  )
                }
              />
            </li>
            <li>
              <FaLinkedinIn
                className="cursor-pointer"
                onClick={() => window.open('https://www.linkedin.com/company/107898404', '_blank')}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Footer
